const isProd = process.env.NODE_ENV === 'production'
const __log = isProd ? function () {} : console.log

function log (...args) {
  const color = args.shift()
  const sign = args.shift()
  __log(`%c${sign}`, `color: ${color}; font-weight: bold;`, ...args)
}

window.log = {
  blue (...args) {
    log('blue', ...args)
  },
  red (...args) {
    log('red', ...args)
  },
  orange (...args) {
    log('orange', ...args)
  },
  green (...args) {
    log('green', ...args)
  },
  pink (...args) {
    log('pink', ...args)
  },
  gray (...args) {
    log('gray', ...args)
  },
  purple (...args) {
    log('purple', ...args)
  },
}
